import withAsyncScript from "./withAsyncScript";

const BASE_URL = "https://maps.googleapis.com/maps/api/js";

export default function withGoogleApi(
  WrappedComponent,
  apiKey,
  libraries = [],
  query = {}
) {
  query.key = apiKey;
  query.libraries = libraries.join(",");

  return withAsyncScript(WrappedComponent, BASE_URL, "google", query);
}
